<template>
	<div class="gallery-view" @click="$store.commit('gallery', [])">
		<div :class="{
			detail: true,
			flipped: flip
		}" :style="{
			backgroundImage: `url('${url}')`
		}">
			<div class="arrow left" @click.stop="prev()">&lt;</div>			
			<div class="arrow right" @click.stop="next()">&gt;</div>			
		</div>
		<div :class="{
			list: true,
			flipped: flip
		}">
			<div @click.stop="open(i)" v-for="(p, i) in _items" :key="i" class="thumb" :style="{
				backgroundImage: 'url(' + p.url + ')'
			}"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				idx: null,
				url: ''
			};
		},
		watch: {
			_items(n) {
				
				this.idx = null;
				this.url = '';

				if (n && n.length > 0 && n[0] && n[0].url) {
					this.open(0);
				}
			}
		},
		props: {
			images: {
				type: Array,
				default() {
					return [];
				}
			},
			flip: {
				type: Boolean,
				default: false
			}
		},
		asyncComputed: {
			_items: {
				lazy: true,
				async get() {
					var calls =  [];

					for (var i = 0; i < this.images.length; ++i) {
						calls.push(this.axios.get('/storage/urls/' + this.images[i].id + '/'));
					}

					var urls = await Promise.all(calls);
					var r = [];

					

					for (var i = 0; i < this.images.length; ++i) {
						r.push({
							id: this.images[i].id,
							tags: this.images[i].tags,
							url: urls[i].data
						});
					}

					

					return r;
				}
			}
		},
		methods: {
			open(idx) {
				

				this.idx = idx;
				if (this.idx < 0) this.idx = this._items.length - 1;
				if (this.idx >= this._items.length) this.idx = 0;
				this.url = this._items[this.idx].url;
			},
			prev() {
				this.open(this.idx - 1);
			},
			next() {
				this.open(this.idx + 1);
			}
		},
		created() {
			const self = this;

			window.addEventListener('keyup', function(e) {
				if ((e.code == 'ArrowLeft' || e.code == 'ArrowUp') && self.idx > 0) {
					self.prev();
				}

				if ((e.code == 'ArrowRight' || e.code == 'ArrowDown') && self.idx < self._items.length - 1) {
					self.next();
				}
			});
		}
	}
</script>

<style lang="scss" scoped>
	.gallery-view {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;

		background-color: rgba(0, 0, 0, 0.781);

		& > .list {
			position: absolute;
			left: 0;
			top: 0;
			width: 200px;
			height: 100%;

			background-color: black;

			overflow-y: auto;

			& > div {
				margin: 20px 0 0 20px;
				width: 160px;
				height: 100px;
				background-color: white;
				cursor: pointer;

				background-position: center center;
				background-repeat: no-repeat;
				background-size: cover;
			}

			&.flipped {
				left: auto;
				right: 0;
			}
		}

		& > .detail {
			position: absolute;
			left: 220px;
			top: 20px;
			right: 20px;
			bottom: 20px;

			background-position: center center;
			background-repeat: no-repeat;
			background-size: contain;

			& > .arrow {
				position: absolute;
				line-height: 50px;
				width: 50px;
				color: white;
				font-weight: bold;
				font-size: 40px;
				text-align: center;
				top: 50%;
				margin-top: -25px;
				background-color: rgba(0, 0, 0, 0.5);
				border-radius: 5px;
				cursor: pointer;

				&.left {
					left: 10px;
				}

				&.right {
					right: 10px;
				}
			}

			&.flipped {
				left: 20px;
				right: 220px;
			}
		}
	}
</style>